import { Skeleton } from "@/components/ui/skeleton.tsx";

export const RequestDisplayChatLoadingState = () => (
  <div className="relative h-full overflow-y-auto rounded-xl border border-gray-200 bg-white p-6">
    <div className="space-y-4">
      <div className="flex justify-start">
        <div className="w-full max-w-[85%] space-y-2 rounded-2xl border border-gray-200 bg-gray-50 p-4">
          <Skeleton height="14px" width="60%" />
          <Skeleton height="14px" width="85%" />
        </div>
      </div>
      <div className="flex justify-end">
        <div className="w-full max-w-[70%] space-y-2 rounded-2xl bg-blue-50 p-4">
          <Skeleton height="14px" width="70%" />
          <Skeleton height="14px" width="50%" />
        </div>
      </div>
      <div className="flex justify-start">
        <div className="w-full max-w-[85%] space-y-2 rounded-2xl border border-amber-200 bg-amber-50 p-4">
          <Skeleton height="14px" width="40%" />
          <Skeleton height="14px" width="75%" />
          <Skeleton height="14px" width="55%" />
        </div>
      </div>
    </div>
  </div>
);
